interface FormFields {
  [key: string]:
    | string
    | FormFieldTypeSelectObject
    | FormFieldTypeSelectObject[];
}

interface FormFieldTypeSelectObject {
  label: string;
  value: string;
  index: number;
}

export const formatFieldsForAttendeesFormsRoute = (
  fields: FormFields,
): Object => {
  const result = {};

  for (let key in fields) {
    const fieldId = key.split('-')[1];
    if (typeof fields[key] === 'string') {
      // for text, textarea, email, date fields
      result[fieldId] = fields[key] ? fields[key] : null;
    } else if (typeof fields[key] === 'boolean') {
      // for checkboxes
      result[fieldId] = fields[key];
    } else if (Array.isArray(fields[key])) {
      // for completed select with multiple options
      result[fieldId] = (fields[key] as FormFieldTypeSelectObject[]).map(
        item => item.index,
      );
    } else if (typeof fields[key] === 'undefined') {
      // for uncompleted select with single or multiple options
      result[fieldId] = [];
    } else if (typeof fields[key] === 'object') {
      // for completed select with a single option
      result[fieldId] = [(fields[key] as FormFieldTypeSelectObject).index];
    }
  }

  return result;
};
